import styled from 'styled-components';
import { Icon } from 'view/atoms';
import { Media, Shadows, FiltersTextBtn } from 'enums';

export const SearchCard = styled.div`
  padding: 14px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.card};
  box-sizing: border-box;
  box-shadow: ${Shadows.lightShadow};
  border-radius: 8px;
  cursor: pointer;

  @media ${Media.notebook} {
    background-color: ${({ theme }) => theme.colors.background};
    padding: 20px;
    margin: 10px 0 0 0;
    border-radius: 10px;
  }
`;
export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const LeftSideBox = styled.div`
  display: flex;
`;

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 6px;

  @media ${Media.notebook} {
    &:first-child {
      line-height: 130%;
      height: 50px;
    }
  }
`;

export const IMGCard = styled.img`
  border-radius: 8px;
  height: 42px;
  width: 42px;
  margin-right: 14px;
  object-fit: cover;
`;

export const ImageBonus = styled.img`
  padding-right: 10px;
  width: 28px;
  height: 28px;

  @media ${Media.notebook} {
    width: 32px;
    height: 32px;
  }
`;

export const IconStyled = styled(Icon)`
  padding-left: 20px;
  width: 20px;
  &:hover {
    filter: ${FiltersTextBtn.yellow1};
  }
`;
